/**
 * Widget configuration with environment-based settings
 */

// Determine the environment
const getEnvironment = (): 'development' | 'staging' | 'production' => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'development';
    } else if (hostname.includes('staging') || hostname.includes('preview')) {
      return 'staging';
    }
  }

  return 'production';
};

// API endpoints based on environment
export const API_ENDPOINTS = {
  development: {
    submitToAirtable: 'http://localhost:3000/api/submit-to-airtable',
    allowedOrigins: ['http://localhost:3000', 'http://localhost:3001']
  },
  staging: {
    submitToAirtable: 'https://staging.where-to-go-417d9.web.app/api/submit-to-airtable',
    allowedOrigins: ['https://staging.where-to-go-417d9.web.app', 'https://staging.safariplanner.org']
  },
  production: {
    submitToAirtable: 'https://where-to-go-417d9.web.app/api/submit-to-airtable',
    allowedOrigins: [
      'https://where-to-go-417d9.web.app',
      'https://safariplanner.org',
      'https://www.safariplanner.org'
    ]
  }
} as const;

// Get current environment config
export const getWidgetConfig = () => {
  const env = getEnvironment();
  return API_ENDPOINTS[env];
};

// Default API endpoint (for backward compatibility)
export const DEFAULT_API_ENDPOINT = API_ENDPOINTS.production.submitToAirtable;

// Rate limiting configuration
export const RATE_LIMIT_CONFIG = {
  maxRequestsPerMinute: 5,
  maxRequestsPerHour: 20,
  maxRequestsPerDay: 50
};

// Validation constraints
export const VALIDATION_CONFIG = {
  fullName: {
    minLength: 2,
    maxLength: 100,
    pattern: /^[a-zA-Z\s\-']{2,100}$/
  },
  email: {
    maxLength: 254,
    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  },
  yearOfTravel: {
    minYear: () => new Date().getFullYear(),
    maxYear: () => new Date().getFullYear() + 10
  }
};